import { Box, useMediaQuery, useTheme } from '@mui/material';
import React from 'react';
import { useLoginContext } from '../../../../../contexts/LoginContext';
import AdditionalEmailAddressesField from '../../../NewAccountStepper/components/DefaultProfile/AdditionalEmailAddressesField';
import WarningMessage from '../../../shared/components/WarningMessage/WarningMessage';
import ProfileDropdown from './ProfileDropdown';
import ProfileEditButtons from './ProfileEditButtons';
import { useStepperContext } from '../../context/StepperContext';
import ProfileName from './ProfileName';

export const ProfileEditPanel: React.FC = () => {
  const { user } = useLoginContext();
  const theme = useTheme();
  const isMobile = !useMediaQuery(theme.breakpoints.up('md'));

  if (!user.extProfiles || user.extProfiles.length === 0) {
    return (
      <Box sx={{ mb: 2 }}>
        <WarningMessage
          message={'No Notification Profiles Found'}
          show={true}
          variant="warning"
        />
        <Box sx={{ mt: 1 }}>
          <ProfileEditButtons />
        </Box>
      </Box>
    );
  } else {
    if (isMobile) return <MobileProfileEditPanel />;
    else return <DesktopProfileEditPanel />;
  }
};

const MobileProfileEditPanel: React.FC = () => {
  const { isNewProfile } = useStepperContext();
  const { user, selectedProfileIndex } = useLoginContext();

  const selectedProfile = user?.extProfiles[selectedProfileIndex ?? 0];
  const shouldShowAdditionalEmails =
    !isNewProfile &&
    selectedProfile?.name?.trim() !== '' &&
    selectedProfile?.additionalEmailAddresses &&
    selectedProfile.additionalEmailAddresses.length > 0 &&
    selectedProfile.additionalEmailAddresses.some(
      (email) => email.trim() !== ''
    );

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
        alignItems: 'flex-start',
      }}
    >
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          gap: 1,
          width: '100%',
        }}
      >
        <ProfileDropdown />
        {shouldShowAdditionalEmails && (
          <Box sx={{ width: '100%' }}>
            <AdditionalEmailAddressesField />
          </Box>
        )}
        <ProfileEditButtons />
      </Box>
      {isNewProfile && <ProfileName />}
    </Box>
  );
};

const DesktopProfileEditPanel: React.FC = () => {
  const { isNewProfile } = useStepperContext();
  const { user, selectedProfileIndex } = useLoginContext();

  const selectedProfile = user?.extProfiles[selectedProfileIndex ?? 0];
  const shouldShowAdditionalEmails =
    !isNewProfile &&
    selectedProfile?.name?.trim() !== '' &&
    selectedProfile?.additionalEmailAddresses &&
    selectedProfile.additionalEmailAddresses.length > 0 &&
    selectedProfile.additionalEmailAddresses.some(
      (email) => email.trim() !== ''
    );

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
        width: '100%',
        alignItems: 'flex-start',
        flexWrap: 'wrap',
      }}
    >
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'row',
          gap: 1,
          width: '100%',
        }}
      >
        <Box sx={{ flex: 1 }}>
          <ProfileDropdown />
        </Box>
        {shouldShowAdditionalEmails && (
          <Box sx={{ flex: 2, width: 'auto' }}>
            <AdditionalEmailAddressesField />
          </Box>
        )}
        <ProfileEditButtons />
      </Box>
      {isNewProfile && <ProfileName />}
    </Box>
  );
};

export default ProfileEditPanel;
